export default {
  formatMetadataForSelect (metadata) {
    return {
      userRoles: this.formatUserRolesForSelect(metadata.user_roles),
      engines: this.formatEnginesForSelect(metadata.engines)
    }
  },
  formatEnginesForSelect (engines) {
    var enginesSelect = []

    Object.keys(engines).map(function (objectKey, index) {
      let engine = {
        id: engines[objectKey].id,
        name: engines[objectKey].name,
        device_css: engines[objectKey].device_css,
        country_css: engines[objectKey].country_css
      }
      enginesSelect.push(engine)
    })
    return enginesSelect
  },
  formatUserRolesForSelect (userRoles) {
    var userRolesSelect = []

    Object.keys(userRoles).map(function (objectKey, index) {
      let role = {
        id: userRoles[objectKey].id,
        name: userRoles[objectKey].name
      }
      userRolesSelect.push(role)
    })
    return userRolesSelect
  }
}



// WEBPACK FOOTER //
// ./src/services/metadata.js